import './check-input.css';

function CheckInput({ title, value, onChange = () => {} }) {
    return (
        <label className='checkbox-container'>
            <input type='checkbox' checked={value} onChange={onChange} />
            <span className="checkbox-checkmark"></span>
            {title}
        </label>
    );
}

export default CheckInput;